<template>
  <div class="container-fluid mt-4">
    <div class="d-flex justify-content-between align-items-top mb-4">
      <div class="ms-4 summary-container w-100 me-4">
        <div
          class="position-relative h-100 w-100"
          v-if="selectedView === 'active'"
        >
          <loading
            v-model:active="isLoading"
            :is-full-page="false"
            loader="dots"
            :opacity="1"
          />
          <table class="table table-bordered text-center align-middle">
            <thead>
              <tr>
                <th rowspan="2"><b>Monthly Client Paying (CAD)</b></th>
                <th rowspan="2"><b>Campaign Actual Spend</b></th>
                <th rowspan="2"><b>Budget</b></th>
                <th rowspan="2"><b>WTI Revenue</b></th>
                <th colspan="2" class="text-start">
                  <b>Campaigns Ending this Month<br />End Date</b>
                </th>
              </tr>
              <tr>
                <th><b>#</b></th>
                <th><b>$</b></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>{{ kpis.monthlyClientPaying }}</b>
                </td>
                <td>
                  <b>{{ kpis.campaignSpend }}</b>
                </td>
                <td>
                  <b>{{ kpis.monthlyTotalBudget }}</b>
                </td>
                <td>
                  <b>{{ kpis.wtiRevenue }}</b>
                </td>
                <td>
                  <b>{{ kpis.endDateNum }}</b>
                </td>
                <td>
                  <b>{{ kpis.endDateDollar }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="position-relative h-100 w-100"
          v-if="selectedView === 'renewal'"
        >
          <loading
            v-model:active="isERLoading"
            :is-full-page="false"
            loader="dots"
            :opacity="1"
          />
          <table
            class="table table-bordered text-center align-middle"
            v-if="!isERLoading"
          >
            <thead>
              <tr>
                <th><b>Month</b></th>
                <th><b>Campaigns Expiring</b></th>
                <th><b>Campaigns Renewing</b></th>
                <th><b>Renewal Rates</b></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(month, index) in ERmonthsData" :key="index">
                <td>
                  <b>{{ month.name }}</b>
                </td>
                <td>{{ month.campaignsExpiringNum }}</td>
                <td>{{ month.campaignsRenewingNum }}</td>
                <td>{{ month.renewalRate }}</td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <b>{{ total.campaignsExpiringNum }}</b>
                </td>
                <td>
                  <b>{{ total.campaignsRenewingNum }}</b>
                </td>
                <td>
                  <b>{{ total.renewalRate }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="position-relative h-100 w-100"
          v-if="selectedView === 'trends'"
        >
          <loading
            v-model:active="isTrendsLoading"
            :is-full-page="false"
            loader="dots"
            :opacity="1"
          />
          <table
            class="table table-bordered text-center align-middle"
            v-if="!isTrendsLoading"
          >
            <thead>
              <tr>
                <th rowspan="2"><b>Month</b></th>
                <th rowspan="2"><b>Monthly Client Paying (CAD)</b></th>
                <th rowspan="2"><b>Campaign Actual Spend</b></th>
                <th rowspan="2"><b>Budget</b></th>
                <th rowspan="2"><b>WTI Revenue</b></th>
                <th colspan="2" class="text-start">
                  <b>Campaigns Ending this Month<br />End Date</b>
                </th>
              </tr>
              <tr>
                <th><b>#</b></th>
                <th><b>$</b></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(month, index) in trendsData" :key="index">
                <td>
                  <b>{{ month.name }}</b>
                </td>
                <td>
                  <b>{{ month.monthlyClientSpend }}</b>
                </td>
                <td>
                  <b>{{ month.totalCost }}</b>
                </td>
                <td>
                  <b>{{ month.budget }}</b>
                </td>
                <td>
                  <b>{{ month.wtiRevenue }}</b>
                </td>
                <td>
                  <b>{{ month.campaignsEndNum }}</b>
                </td>
                <td>
                  <b>{{ month.campaignsEndCost }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="d-flex">
        <div class="me-2">
          <select
            id="viewSelect"
            v-model="selectedView"
            class="form-select medium-select"
          >
            <option value="active">Active Campaigns</option>
            <option value="renewal">Renewal Summary</option>
            <option value="trends">Trends</option>
          </select>
        </div>
        <div v-if="selectedView === 'active'">
          <VueDatePicker
            v-model="month"
            month-picker
            :min-date="startMonth"
            :max-date="new Date()"
            format="MMMM yyyy"
          />
        </div>
      </div>
    </div>
    <div
      class="position-relative admin-campaign-table mb-4 mx-4"
      v-show="selectedView === 'active'"
    >
      <loading
        v-model:active="isLoading"
        :is-full-page="false"
        loader="dots"
        :opacity="1"
      />
      <table
        :bAutoWidth="true"
        class="table table-hover table-striped"
        id="campaigninfo-table"
      >
        <thead>
          <tr>
            <th>Campaign Name</th>
            <th>Category</th>
            <th>HS Link</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Date<br />Invoiced<br />Til</th>
            <th>Monthly<br />Client<br />Paying(Invoice)</th>
            <th>MonthlyClientPayingInvoice-Hidden</th>
            <th>Monthly<br />Client<br />Paying (CAD)</th>
            <th>ClientSpend-Hidden</th>
            <th>Campaign<br />Actual<br />Spend</th>
            <th>ActualSpend-Hidden</th>
            <th>Budget</th>
            <th>Revenue-Hidden</th>
            <th>WTI<br />Revenue</th>
            <th>Revenue-Hidden</th>
            <th>Linkedin<br />Actual<br />Spend</th>
            <th>LinkedIn-Hidden</th>
            <th>Meta<br />Actual<br />Spend</th>
            <th>Meta-Hidden</th>
            <th>Google<br />Actual<br />Spend</th>
            <th>Google-Hidden</th>
            <th></th>
          </tr>
        </thead>
        <tfoot class="tableTotalRow">
          <tr>
            <th></th>
            <th>Total:</th>
            <th colspan="6"></th>
            <th colspan="2" class="totalmonthlyClientSpend text-end"></th>
            <th colspan="2" class="totalCampaignActualSpend text-end"></th>
            <th colspan="2" class="monthlyTotalBudget text-end"></th>
            <th colspan="2" class="monthlyTotalWTIRevenue text-end"></th>
            <th colspan="2" class="totalLISpend text-end"></th>
            <th colspan="2" class="totalMetaSpend text-end"></th>
            <th colspan="2" class="totalGoogleSpend text-end"></th>
            <th></th>
          </tr>
        </tfoot>
      </table>
    </div>
    <div
      class="position-relative admin-campaign-table mb-4 mx-4"
      v-show="selectedView === 'renewal'"
    >
      <loading
        v-model:active="isERLoading"
        :is-full-page="false"
        loader="dots"
        :opacity="1"
      />
      <DatatableComponent
        :data="ERcampaigns"
        :options="{
          select: true,
          paging: false,
          searching: false,
          info: false,
          responsive: true,
          order: [[2, 'asc']],
          autoWidth: false,
        }"
        :keys="[
          'Month Expired',
          'Month Expired-Hidden',
          'Campaign Name',
          'Reason Group',
          'Reason',
        ]"
        :columns="columns1"
        v-if="!isERLoading"
      />
    </div>
  </div>
  <Modal id="editClient">
    <template v-slot:title> {{ activeName }}</template>
    <template v-slot:body>
      <!-- <div class="form-group mb-3">
        <label for="iscampaignClientSelectEdit" class="form-label"
          >Category</label
        >
        <select
          class="form-select mb-0"
          v-model="activeClientType"
          id="iscampaignClientSelectEdit"
        >
          <option
            v-for="(item, key) in isClientListEdit"
            :key="key"
            :value="item"
          >
            {{ key }}
          </option>
        </select>
      </div> -->
      <Input v-model="activeHsLink1" type="url" label="HS Link" />
      <div class="form-group mb-3">
        <label for="invoicedTil" class="form-label">Invoiced Til</label>
        <input
          type="date"
          class="form-control"
          id="invoicedTil"
          v-model="activeInvoicedTil"
        />
      </div>
      <!-- <Input
        v-model="activeMonthlyClientPayingInvoice"
        type="number"
        label="Monthly Client Paying(Invoice)"
      /> -->
      <Input
        v-model="activeMonthlyClientSpend"
        type="number"
        label="Monthly Client Paying(CAD)"
      />
      <!-- <div class="form-group mb-3">
        <label for="contratEndDate" class="form-label"
          >Current Contract End Date</label
        >
        <input
          type="date"
          class="form-control"
          id="contratEndDate"
          v-model="activeContractEndDate"
        />
      </div> -->

      <!-- <Input v-model="freeTrailUntil" type="date" label="Free Trail Until" /> -->
      <!-- <Input v-model="hsLink1" type="url" label="HS Link #1" /> -->
      <!-- <Input v-model="hsLink2" type="url" label="HS Link #2" />
      <Input v-model="hsLink3" type="url" label="HS Link #3" />
      <Input v-model="hsLink4" type="url" label="HS Link #4" />
      <Input v-model="hsLink5" type="url" label="HS Link #5" /> -->
      <p class="error-msg">{{ updateErrorMsg }}</p>
      <button
        type="button"
        class="btn btn-primary wti-btn-black"
        @click="updateClient"
      >
        <span
          v-if="submitting"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        {{ submitting ? "" : "Update!" }}
      </button>
    </template>
  </Modal>
</template>

<style lang="sass" scoped>
@use "@/assets/vars.sass" as *
.admin-campaign-table
  min-height: 30vh
  overflow-y: auto
  .dataTable
    width: 99%
    thead
      th
        white-space: nowrap
    tbody
      td
        word-wrap: break-word
    tfoot.tableTotalRow
      th
        background-color: $Main
        color: white
        white-space: nowrap
select.form-select.small-select
  padding: 10px 12px
  min-width: 100px
select.form-select.small-select#listCampaignStatus
  padding: 10px 30px 10px 12px
  min-width: 100px
.kpi-container
  border: 1px solid $LightGreyBorder
  border-radius: 20px
  width: 100%
  min-height: 101px
  height: 100%
  .kpi-header
    font-weight: 600
    font-size: 14px
    line-height: 20px
    color: $Main
    padding: 23px 10px 12px
    +laptop
      font-size: 15px
    +mobile
      font-size: 14px
      padding: 14px 14px 12px
  .kpi-value
    font-weight: 600
    font-size: 16px
    line-height: 23px
    padding: 0 10px 22px
    color: $Main
    +laptop
      font-size: 17px
    +mobile
      font-size: 16px
      padding: 0 14px 14px
    span
      font-weight: 600
  +mobile
    margin-bottom: 10px
    height: 90%
.medium-select
  padding: 10px 12px
  min-width: 180px
.summary-container
  min-height: 200px
  table.table
    border: 1px solid green
</style>

<script>
import { ref } from "vue";
import api from "@/services/BackendConnection";
import moment from "moment";
import $ from "jquery";

import DatatableComponent from "@/components/DatatableComponent.vue";
import Modal from "@/components/Modal.vue";
import Input from "./Input.vue";

export default {
  name: "ListCampaignsInfoAdmin",
  setup(props) {
    var self = this;
    return {
      campaigns: ref(null),
      ERcampaigns: ref(null),
      ERmonthsData: ref(null),
      trendsData: ref(null),
      month: ref({
        month: moment().utc().month(),
        year: moment().utc().year(),
      }),
      startMonth: moment("2023-10-01").utc().toDate(),
      isLoading: ref(true),
      isERLoading: ref(true),
      isTrendsLoading: ref(true),
      activeId: ref(null),
      activeName: ref(null),
      // activeClientType: ref(null),
      // activeContractEndDate: ref(null),
      activeHsLink1: ref(null),
      activeInvoicedTil: ref(null),
      // activeMonthlyClientPayingInvoice: ref(null),
      activeMonthlyClientSpend: ref(null),
      activeIndex: ref(null),
      submitting: ref(false),
      monthlyClientSpend: ref(null),
      freeTrailUntil: ref(null),
      hsLink1: ref(null),
      hsLink2: ref(null),
      hsLink3: ref(null),
      hsLink4: ref(null),
      hsLink5: ref(null),
      // monthlyClientPayingInvoice: ref(null),
      totalmonthlyClientSpend: ref(null),
      totalCampaignActualSpend: ref(null),
      monthlyTotalWTIRevenue: ref(null),
      monthlyTotalBudget: ref(null),
      campaignsEndNum: ref(null),
      campaignsEndCost: ref(null),
      isClientListEdit: ref({
        Client: 2,
        Internal: 3,
      }),
      selectedView: ref("active"),
      updateErrorMsg: ref(null),
    };
  },
  data() {
    var self = this;
    return {
      columns: [
        {
          data: "name",
          defaultContent: "-",
          className: "text-break",
        },
        {
          data: "category",
          defaultContent: "-",
          className: "text-break",
        },
        {
          data: "hsLink1",
          defaultContent: "",
          className: "text-break",
          orderable: false,
          render: function (data, type, row, meta) {
            if (type === "display") {
              var html = '<div class="d-flex flex-wrap">';
              var hsLinks = [
                "hsLink1",
                "hsLink2",
                "hsLink3",
                "hsLink4",
                "hsLink5",
              ];
              hsLinks.forEach((hsLink) => {
                if (row[hsLink]) {
                  html +=
                    '<div class="p-1" style="max-width: 100%"><a href="' +
                    row[hsLink] +
                    '" target="_blank" class="btn btn-primary btn-sm w-100">' +
                    '<img src="' +
                    self.getImgUrl("hubspot.svg") +
                    '" style="height:12px; color:white"/>' +
                    "</a></div>";
                }
              });
              html += "</div>";
              return html;
            }
          },
        },
        {
          data: "startDateStr",
          type: "date",
          defaultContent: "-",
        },
        {
          data: "endDateStr",
          type: "date",
          defaultContent: "null",
        },
        {
          data: "invoicedTil",
          type: "date",
          defaultContent: "null",
        },
        {
          data: "monthlyClientPayingInvoice",
          defaultContent: "$0",
          className: "text-break",
          orderData: [7],
          targets: [6],
          render: function (data, type, row, meta) {
            if (type === "display" && data) {
              var cost;
              cost = data
                ? "$" +
                  data.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "unknown";
              return cost;
            }
          },
        },
        {
          data: "monthlyClientPayingInvoice",
          visible: false,
          searchable: false,
          targets: [7],
        },
        {
          data: "monthlyClientSpend",
          defaultContent: "$0",
          className: "text-break",
          orderData: [9],
          targets: [8],
          render: function (data, type, row, meta) {
            if (type === "display" && data) {
              var cost;
              cost = data
                ? "$" +
                  data.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : "unknown";
              return cost;
            }
          },
        },
        {
          data: "monthlyClientSpend",
          visible: false,
          searchable: false,
          targets: [9],
        },
        {
          data: "totalCost",
          defaultContent: "$0",
          className: "text-break",
          orderData: [11],
          targets: [10],
          render: function (data, type, row, meta) {
            if (type === "display" && data) {
              var cost = data.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
              return "$" + cost;
            }
          },
        },
        {
          data: "totalCost",
          visible: false,
          searchable: false,
          targets: [11],
        },
        {
          data: "budget",
          defaultContent: "$0",
          className: "text-break",
          orderData: [13],
          targets: [12],
          render: function (data, type, row, meta) {
            if (type === "display" && data) {
              var cost = data.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
              return "$" + cost;
            }
          },
        },
        {
          data: "budget",
          visible: false,
          searchable: false,
          targets: [13],
        },
        {
          data: "wtiRevenue",
          defaultContent: "$0",
          className: "text-break",
          orderData: [15],
          targets: [14],
          render: function (data, type, row, meta) {
            if (type === "display" && data) {
              var cost = data.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
              return "$" + cost;
            }
          },
        },
        {
          data: "wtiRevenue",
          visible: false,
          searchable: false,
          targets: [15],
        },
        {
          data: "linkedin.cost",
          defaultContent: "$0",
          className: "text-break",
          orderData: [17],
          targets: [16],
          render: function (data, type, row, meta) {
            if (type === "display" && data) {
              var cost = data.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
              return "$" + cost;
            }
          },
        },
        {
          data: "linkedin.cost",
          visible: false,
          searchable: false,
          targets: [17],
        },
        {
          data: "meta.cost",
          defaultContent: "$0",
          className: "text-break",
          orderData: [19],
          targets: [18],
          render: function (data, type, row, meta) {
            if (type === "display" && data) {
              var cost = data.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
              return "$" + cost;
            }
          },
        },
        {
          data: "meta.cost",
          visible: false,
          searchable: false,
          targets: [19],
        },
        {
          data: "google.cost",
          defaultContent: "$0",
          className: "text-break",
          orderData: [21],
          targets: [20],
          render: function (data, type, row, meta) {
            if (type === "display" && data) {
              var cost = data.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
              return "$" + cost;
            }
          },
        },
        {
          data: "google.cost",
          visible: false,
          searchable: false,
          targets: [21],
        },
        {
          data: null,
          defaultContent: "-",
          orderable: false,
          className: "text-end",
          render: function (data, type, row) {
            if (type === "display") {
              $(document).on(
                "click",
                "#editClient-" + row.id + "_" + row.index,
                function () {
                  self.updateActiveate(
                    row.id,
                    row.name,
                    // row.clientType,
                    row.hsLink1,
                    row.invoicedTil,
                    // row.monthlyClientPayingInvoice,
                    row.monthlyClientSpend,
                    row.index
                    // row.contractEndDate,
                    // row.freeTrailUntil,
                    // row.hsLink2,
                    // row.hsLink3,
                    // row.hsLink4,
                    // row.hsLink5,
                  );
                }
              );
              var html =
                '<button class="btn btn-primary" id="editClient-' +
                row.id +
                "_" +
                row.index +
                '" data-bs-toggle="modal" data-bs-target="#editClient">' +
                '<img src="' +
                self.getImgUrl("edit.svg") +
                '" style="height:12px; color:white"/>' +
                "</button>";
              return html;
            }
          },
        },
      ],
      columns1: [
        {
          data: "endDate",
          type: "date",
          defaultContent: "null",
          width: "10%",
          className: "text-start",
          orderData: [1],
          targets: [0],
          render: function (data, type, row) {
            if (type === "display" && data) {
              return moment(data).format("MMM-YYYY");
            }
          },
        },
        {
          data: "endDate",
          visible: false,
          searchable: false,
          targets: [1],
        },
        {
          data: "name",
          defaultContent: "-",
          className: "text-start text-break",
          width: "30%",
        },
        {
          data: "reasonGroup",
          defaultContent: "-",
          className: "text-start text-break",
          width: "20%",
        },
        {
          data: "reason",
          defaultContent: "-",
          className: "text-start text-break",
          width: "40%",
        },
      ],
    };
  },
  components: {
    DatatableComponent,
    Modal,
    Input,
  },
  computed: {
    activeDateRange() {
      var newDate = moment.utc();
      newDate.set("year", this.month.year);
      newDate.set("month", this.month.month);
      newDate.set("date", 1);
      var endDate = newDate.clone().endOf("month");
      if (endDate > moment().utc()) {
        endDate = moment().utc();
      }
      return { start: newDate, end: endDate };
    },
    kpis() {
      var monthlyEndCampaignCost =
        this.campaignsEndCost && this.campaignsEndCost > 0
          ? "$" +
            this.campaignsEndCost.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })
          : "$0.00";
      var data = {
        monthlyClientPaying: this.totalmonthlyClientSpend,
        campaignSpend: this.totalCampaignActualSpend,
        monthlyTotalBudget: this.monthlyTotalBudget,
        wtiRevenue: this.monthlyTotalWTIRevenue,
        endDateNum: this.campaignsEndNum,
        endDateDollar: monthlyEndCampaignCost,
      };
      return data;
    },
    total() {
      if (this.ERmonthsData) {
        var result = {
          campaignsExpiringNum: 0,
          campaignsRenewingNum: 0,
          renewalRate: null,
        };
        this.ERmonthsData.forEach((month) => {
          result.campaignsExpiringNum += month.campaignsExpiringNum;
          result.campaignsRenewingNum += month.campaignsRenewingNum;
        });
        result.renewalRate =
          (
            (result.campaignsRenewingNum / result.campaignsExpiringNum) *
            100
          ).toLocaleString(undefined, {
            maximumFractionDigits: 2,
          }) + "%";
        return result;
      }
    },
  },
  methods: {
    getCampaignsList() {
      var _this = this;
      _this.isLoading = true;
      var startDate = _this.activeDateRange.start;
      var endDate = _this.activeDateRange.end;
      var info = {
        start: startDate.format("YYYY-MM-DD"),
        end: endDate.format("YYYY-MM-DD"),
      };
      api()
        .getCampaignsList(info)
        .then((res) => {
          if (res.data) {
            _this.campaigns = res.data.campaigns;
            _this.campaignsEndNum = res.data.campaignsEndNum;
            _this.campaignsEndCost = res.data.campaignsEndCost;
            _this.formatedTotalVals();
            _this.isLoading = false;
          }
        });
    },
    getCampaignsERList() {
      var _this = this;
      _this.isERLoading = true;
      // var startDate = _this.activeDateRange.start;
      // var endDate = moment(_this.activeDateRange.start).clone().endOf("month");
      var info = {
        // start: startDate.format("YYYY-MM-DD"),
        // end: endDate.format("YYYY-MM-DD"),
      };
      api()
        .getCampaignsERList(info)
        .then((res) => {
          if (res.data) {
            _this.ERmonthsData = res.data.months;
            _this.ERcampaigns = res.data.lists;
            _this.isERLoading = false;
          }
        });
    },
    getTrends() {
      var _this = this;
      _this.isTrendsLoading = true;
      api()
        .getTrends()
        .then((res) => {
          if (res.data) {
            _this.trendsData = res.data.months;
            _this.isTrendsLoading = false;
          }
        });
    },
    updateActiveate(
      val1,
      val2,
      val3,
      val4,
      val5,
      val6
      // val7
      // val8,
      // val9,
      // val10
      // val11,
      // val12,
      // val13
    ) {
      this.activeId = val1;
      this.activeName = val2;
      // this.activeClientType = val3;
      // this.activeContractEndDate = val5;
      this.activeHsLink1 = val3;
      this.activeInvoicedTil = val4;
      // this.activeMonthlyClientPayingInvoice = val5;
      this.activeMonthlyClientSpend = val5;
      this.activeIndex = val6;
      // this.freeTrailUntil = val5;
      // this.hsLink2 = val9;
      // this.hsLink3 = val10;
      // this.hsLink4 = val11;
      // this.hsLink5 = val12;
    },
    getImgUrl(fileName) {
      return new URL(`../assets/${fileName}`, import.meta.url).href;
    },
    updateClient() {
      var _this = this;
      var info = {
        campaignId: this.activeId,
        index: this.activeIndex,
        hsLink1: this.activeHsLink1,
        invoicedTil: this.activeInvoicedTil,
        // monthlyClientPayingInvoice: this.activeMonthlyClientPayingInvoice,
        monthlyClientSpend: this.activeMonthlyClientSpend,
        // freeTrailUntil: this.freeTrailUntil,
        // clientType: this.activeClientType,
        // contractEndDate: this.activeContractEndDate,
        // hsLink2: this.hsLink2,
        // hsLink3: this.hsLink3,
        // hsLink4: this.hsLink4,
        // hsLink5: this.hsLink5,
      };
      _this.submitting = true;
      api()
        .updateCampaignInfoAdmin(info)
        .then((res) => {
          if (res.data) {
            _this.submitting = false;
            if (res.data.success) {
              this.rerender("editClientclose");
            } else {
              _this.updateErrorMsg = res.data.error;
            }
          }
        });
    },
    rerender(id) {
      var key = this.$store.state.componentKey;
      this.$store.commit("setComponentKey", key + 1);
      var myModal = document.getElementById(id);
      myModal.click();
    },
    formatedTotalVals() {
      if (this.campaigns) {
        var _this = this;
        var metaSpend = this.campaigns.reduce((acc, curr) => {
          return acc + curr.meta.cost;
        }, 0);
        var totalMetaSpend =
          metaSpend == 0.0
            ? "$" + 0
            : "$" +
              metaSpend.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
        var LIspend = this.campaigns.reduce((acc, curr) => {
          return acc + curr.linkedin.cost;
        }, 0);
        var totalLISpend =
          LIspend == 0.0
            ? "$" + 0
            : "$" +
              LIspend.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
        var googleSpend = this.campaigns.reduce((acc, curr) => {
          return acc + curr.google.cost;
        }, 0);
        var totalGoogleSpend =
          googleSpend == 0
            ? "$0.00"
            : "$" +
              googleSpend.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
        var spend = this.campaigns.reduce((acc, curr) => {
          return acc + curr.totalCost;
        }, 0);
        this.totalCampaignActualSpend =
          spend == 0
            ? "$0.00"
            : "$" +
              spend.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
        var monthlyClientSpend = this.campaigns.reduce((acc, curr) => {
          return acc + curr.monthlyClientSpend;
        }, 0);
        this.totalmonthlyClientSpend =
          monthlyClientSpend == 0
            ? "$0.00"
            : "$" +
              monthlyClientSpend.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
        var monthlyTotalBudget = this.campaigns.reduce((acc, curr) => {
          return acc + curr.budget;
        }, 0);
        this.monthlyTotalBudget =
          monthlyTotalBudget == 0
            ? "$0.00"
            : "$" +
              monthlyTotalBudget.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
        var WTIRevenue = monthlyClientSpend - spend;
        this.monthlyTotalWTIRevenue =
          WTIRevenue == 0
            ? "$0.00"
            : "$" +
              WTIRevenue.toLocaleString(undefined, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              });
        $(document).ready(function () {
          // $("#campaigninfo-table .totalViews").text(totalViews);
          $("#campaigninfo-table .totalMetaSpend").text(totalMetaSpend);
          // $("#campaigninfo-table .totalInsSpend").text(totalInsSpend);
          $("#campaigninfo-table .totalLISpend").text(totalLISpend);
          $("#campaigninfo-table .totalGoogleSpend").text(totalGoogleSpend);
          $("#campaigninfo-table .totalCampaignActualSpend").text(
            _this.totalCampaignActualSpend
          );
          $("#campaigninfo-table .totalmonthlyClientSpend").text(
            _this.totalmonthlyClientSpend
          );
          $("#campaigninfo-table .monthlyTotalWTIRevenue").text(
            _this.monthlyTotalWTIRevenue
          );
          $("#campaigninfo-table .monthlyTotalBudget").text(
            _this.monthlyTotalBudget
          );
        });
      }
    },
    initializeDataTable() {
      var _this = this;
      this.dataTableInstance = $("#campaigninfo-table").DataTable({
        data: [],
        columns: this.columns,
        select: true,
        paging: false,
        searching: false,
        info: false,
        responsive: true,
        fixedHeader: true,
        order: [[0, "asc"]],

        // createdRow: function (row, data, dataIndex) {
        //   const cells = row.querySelectorAll("td");
        //   const revenueCell = cells[10];
        //   if (!revenueCell) return;
        //   revenueCell.classList.remove("highlight-red", "highlight-green");
        //   if (
        //     data.monthlyClientPayingInvoice &&
        //     data.wtiRevenue !== undefined
        //   ) {
        //     const threshold =
        //       Number(data.monthlyClientPayingInvoice) < 1000 ? 0.9 : 0.8;
        //     const isBelowThreshold =
        //       Number(data.wtiRevenue) <
        //       threshold * Number(data.monthlyClientPayingInvoice);
        //     revenueCell.classList.add(
        //       isBelowThreshold ? "highlight-red" : "highlight-green"
        //     );
        //   }
        // },
      });
    },
  },
  mounted() {
    this.initializeDataTable();
    this.getCampaignsList();
    // this.getCampaignsERList();
    // this.getTrends();
  },
  watch: {
    month(newVal, oldVal) {
      this.getCampaignsList();
    },
    selectedView(newVal) {
      if (
        newVal === "renewal" &&
        (this.ERcampaigns == null || this.ERmonthsData == null)
      ) {
        this.getCampaignsERList();
      } else if (newVal === "trends" && this.trendsData == null) {
        this.getTrends();
      }
    },
    campaigns(newValue) {
      if (this.dataTableInstance) {
        this.dataTableInstance.clear().rows.add(newValue).draw();
      }
    },
  },
};
</script>